import { render, staticRenderFns } from "./moveFeatureddata.vue?vue&type=template&id=23b6dbc4&scoped=true&"
import script from "./moveFeatureddata.vue?vue&type=script&lang=js&"
export * from "./moveFeatureddata.vue?vue&type=script&lang=js&"
import style0 from "./moveFeatureddata.vue?vue&type=style&index=0&id=23b6dbc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6dbc4",
  null
  
)

export default component.exports